import React from 'react'
import {useIntl} from 'react-intl'
import {UsersList} from './users-list/UsersList'
import {ListViewProvider} from './users-list/core/ListViewProvider'
import {QueryRequestProvider} from './users-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './users-list/core/QueryResponseProvider'
import {AzPageHeader} from '../../components/AzPageHeader'
import UsersSelfServiceHint from './UsersSelfServiceHint'

const UsersPage = () => {
  const intl = useIntl()

  return (
    <>
      <AzPageHeader
        title={intl.formatMessage({id: 'MENU.USERS_MANAGEMENT'})}
        subtitle={intl.formatMessage({id: 'USERS.PAGE_DESCRIPTION'})}
      />
      <UsersSelfServiceHint />
      <ListViewProvider>
        <QueryRequestProvider>
          <QueryResponseProvider>
            <UsersList />
          </QueryResponseProvider>
        </QueryRequestProvider>
      </ListViewProvider>
    </>
  )
}

export default UsersPage
